<template>
    <div >
        <md-card v-if="!noCard"
                @mouseleave.native="onMouseLeave"
                :data-count="hoverCount"
                class="md-card-chart"
        >
            <md-card-header
                    @mouseenter.native="onMouseOver"
                    :data-header-animation="headerAnimation"
                    :class="[
        { hovered: imgHovered },
        { hinge: headerDown },
        { fadeInDown: fixedHeader },
        { animated: true },
        { [getClass(backgroundColor)]: true },
        { 'md-card-header-text': HeaderText },
        { 'md-card-header-icon': HeaderIcon }
      ]"
            >
                <div v-if="chartInsideHeader" :id="chartId" class="ct-chart"></div>
                <slot name="chartInsideHeader"></slot>
            </md-card-header>

            <md-card-content class="df aic">
                <div v-if="chartInsideContent" :id="chartId" class="ct-chart" style="width: 100%"></div>
                <div
                        class="md-card-action-buttons text-center"
                        v-if="headerAnimation === 'true'"
                >
                    <md-button
                            class="md-danger md-simple fix-broken-card"
                            @click="fixHeader"
                            v-if="headerDown"
                    >
                        <slot name="fixed-button"></slot> Fix Header!
                    </md-button>
                    <slot name="first-button"></slot>
                    <slot name="second-button"></slot>
                    <slot name="third-button"></slot>
                </div>
                <slot name="content"></slot>
            </md-card-content>

            <md-card-actions md-alignment="left" v-if="!noFooter">
                <slot name="footer"></slot>
            </md-card-actions>
        </md-card>
        <div v-if="noCard" style="display: flex; align-items: center;height: 100%;" :class="{'fdc':chartType!=='Pie'}">
            <div :id="chartId" class="ct-chart" style="height: 100%;min-width: 50%;"></div>
            <div>
                <div v-for="(legendItem,index) in legend" style="display: flex;align-items: center;">
                    <i v-if="index == 0" class="fa fa-circle text-info"></i>
                    <i v-else-if="index == 1" class="fa fa-circle text-danger"></i>
                    <i v-else-if="index == 2" class="fa fa-circle text-warning"></i>
                    <i v-else-if="index == 3" class="fa fa-circle text-primary"></i>
                    <i v-else-if="index == 4" class="fa fa-circle" style="color: #4caf50"></i>
                    <i v-else-if="index == 5" class="fa fa-circle" style="color: #ff10db"></i>
                    <i v-else-if="index == 6" class="fa fa-circle" style="color: #999999"></i>
                    <i v-else-if="index == 7" class="fa fa-circle" style="color: #dd4b39"></i>
                    <i v-else-if="index == 8" class="fa fa-circle" style="color: #35465c"></i>
                    <i v-else-if="index == 9" class="fa fa-circle" style="color: #e52d27"></i>
                    <i v-else-if="index == 10" class="fa fa-circle" style="color: #55acee"></i>
                    <i v-else-if="index == 11" class="fa fa-circle" style="color: #cc2127"></i>
                    <span class="ml10"><slot name="legend" v-bind:legend="legendItem" >{{ legendItem }}</slot></span>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
  name: "chart-card",
  props: {
    HeaderText: Boolean,
    HeaderIcon: Boolean,
    noFooter: Boolean,
    noCard: Boolean,
    chartInsideContent: Boolean,
    chartInsideHeader: Boolean,
    chartType: {
      type: String,
      default: "Line" // Line | Pie | Bar
    },
    headerAnimation: {
      type: String,
      default: "true"
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    chartResponsiveOptions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    chartAnimation: {
      type: Array,
      default: () => {
        return [];
      }
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          labels: [],
          series: []
        };
      }
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    legend: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      hoverCount: 0,
      imgHovered: false,
      fixedHeader: false,
      chartId: "no-id"
    };
  },
  computed: {
    headerDown() {
      return this.hoverCount > 15;
    }
  },
  methods: {
    headerBack: function() {
      this.fixedHeader = false;
    },
    fixHeader: function() {
      this.hoverCount = 0;
      this.fixedHeader = true;

      setTimeout(this.headerBack, 480);
    },
    onMouseOver: function() {
      if (this.headerAnimation === "true") {
        this.imgHovered = true;
        this.hoverCount++;
      }
    },
    onMouseLeave: function() {
      if (this.headerAnimation === "true") {
        this.imgHovered = false;
      }
    },

    getClass: function(backgroundColor) {
      return "md-card-header-" + backgroundColor + "";
    },
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart() {
      var chartIdQuery = `#${this.chartId}`;
      if (!document.querySelector(chartIdQuery)) return;
      let chart = this.$Chartist[this.chartType](
        chartIdQuery,
        this.chartData,
        this.chartOptions,
        this.chartAnimation
      );
      // задержка для отрисовки после анимации перехода
      // определяет не правильные размеры
      setTimeout(()=>{chart.update()},310)
    },
    /***
     * Assigns a random id to the chart
     */
    updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = `div_${randomInt}`;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted() {
    this.updateChartId();
    this.$nextTick(this.initChart);
  }
};
</script>
